import { useMount } from '@tiger/hooks';
import Icon from '@tiger/icons';
import lodash from 'lodash';
import { FC, useEffect, useRef, useState } from 'react';
import { $Formutil, EasyField, withForm } from 'react-bootstrap-formutil';
import HashLink from 'components/HashLink';
import classlist from 'utils/classlist';
import { getSearchCountryData } from 'utils/helper';
import { TelcodesCountry, TelcodesCountryItem } from './type';

interface PortalMobileProps {
    hide(): void;
    countryData: TelcodesCountry[];
    $formutil: $Formutil<{ search: string }>;
    telcode: string;
    onChange: (value: string) => void;
}

const PortalMobile: FC<PortalMobileProps> = ({ hide, countryData, $formutil, telcode, onChange }) => {
    const { search } = $formutil.$params;
    const [originalLists, setOriginalLists] = useState<TelcodesCountryItem[]>([]);
    const [result, setResult] = useState<TelcodesCountryItem[] | null>(null);
    const telcodeRefs = useRef<Record<string, HTMLDivElement | null>>({});

    // 搜索
    const handleSearch = () => {
        if (countryData.length > 0) {
            const tempSearch = search.toLowerCase();

            setResult(() => {
                if (tempSearch) {
                    const tempData = getSearchCountryData(countryData, tempSearch).reduce(
                        (prev: TelcodesCountryItem[], cur: TelcodesCountry) => prev.concat(cur.items),
                        []
                    );

                    return lodash.uniqBy(tempData, 'country_code');
                }

                return originalLists;
            });
        }
    };

    useMount(() => {
        const countries = countryData.reduce(
            (list: TelcodesCountryItem[], ret: TelcodesCountry) => list.concat(ret.items),
            []
        );

        const tempAllLists = lodash.uniqBy(countries, 'country_code');

        setOriginalLists(tempAllLists);
        setResult(tempAllLists);
    });

    // 定位到current country
    useEffect(() => {
        if (result?.length && telcodeRefs.current[telcode]) {
            const el = telcodeRefs.current[telcode]!;
            const parent = el.parentNode as HTMLDivElement;
            const rect = el.getBoundingClientRect();

            parent && (parent.scrollTop = rect.top - 39);
        }
    }, [telcode, result]);

    return (
        <div className="telcodes-expand-panel-mobile">
            <header className="search">
                <Icon type="search" className="search-icon" width="24px" height="24px" />
                <EasyField
                    name="search"
                    className="form-control"
                    $parser={(value, $setViewValue) => $setViewValue(value.trim())}
                    $onFieldChange={handleSearch}
                />
                <HashLink className="search-cancel-btn" onClick={hide}>
                    <Icon type="close" width="20px" height="20px" />
                </HashLink>
            </header>
            <section className="list">
                {result?.map(item => (
                    <div
                        key={item.country_code}
                        className={classlist('item', {
                            current: telcode === item.tel_code
                        })}
                        ref={el => el && (telcodeRefs.current[item.tel_code] = el)}
                        onClick={() => onChange(item.tel_code)}>
                        {item.country} +{item.tel_code}
                    </div>
                ))}
                {result && result.length === 0 && (
                    <div className="no-result">
                        <p className="msg">{__('There are no matching countries or regions')}</p>
                        <p className="tip">
                            {__(
                                'You can choose the country or region, such as "United States" or the calling code "1"'
                            )}
                        </p>
                    </div>
                )}
            </section>
        </div>
    );
};

export default withForm(PortalMobile);
